import { render, staticRenderFns } from "./RoleAddDialog.vue?vue&type=template&id=ffadc2a6&scoped=true"
import script from "./RoleAddDialog.vue?vue&type=script&lang=js"
export * from "./RoleAddDialog.vue?vue&type=script&lang=js"
import style0 from "./RoleAddDialog.vue?vue&type=style&index=0&id=ffadc2a6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffadc2a6",
  null
  
)

export default component.exports